import type { QueryField } from '../index'

export type NestedCalendarDefinitionGroup = {
  key: string
  label: string
  definitionHandle: string
  fields: QueryField[]
  selected: QueryField | null
}

export const getNestedCalendarDefinitionGroups = (
  calendarField: QueryField | null | undefined,
  calendarFieldMap: Record<string, string> | undefined,
  fields: QueryField[],
): NestedCalendarDefinitionGroup[] => {
  if (!calendarField) return []
  const leaf = calendarField.value.split('.').pop() || calendarField.value
  const prefixes = [`${leaf}.`, `${calendarField.value}.`]
  const seen = new Set<string>()
  const nested = fields.filter((field) => {
    const value = String(field.value || '')
    if (seen.has(value)) return false
    const matches =
      Boolean(field.definitionHandle) &&
      prefixes.some((prefix) => value.startsWith(prefix))
    if (matches) seen.add(value)
    return matches
  })
  const byDefinition = new Map<string, QueryField[]>()
  for (const field of nested) {
    const definitionHandle = field.definitionHandle
    if (!definitionHandle) continue
    const list = byDefinition.get(definitionHandle) ?? []
    list.push(field)
    byDefinition.set(definitionHandle, list)
  }
  return [...byDefinition.entries()].map(([definitionHandle, groupFields]) => {
    const mapped =
      calendarFieldMap?.[definitionHandle] ??
      calendarFieldMap?.[definitionHandle.split('/').pop() ?? '']
    const selected =
      groupFields.find((field) => {
        const fieldLeaf = field.value.split('.').pop() || field.value
        return mapped === field.value || mapped === fieldLeaf
      }) ?? null
    return {
      key: `calendar-nested-${definitionHandle}`,
      label: definitionHandle.split('/').pop() || definitionHandle,
      definitionHandle,
      fields: groupFields,
      selected,
    }
  })
}
